import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, RotateCcw, Truck, Clock, Info } from 'lucide-react';

const REFUND_POLICY_POINTS = [
  'Every customer must be encouraged to check the product before payment to the delivery agent.',
  'If there are sizing issues or defects, or if the customer does not want not to take the product, they must be encouraged to return on spot to the delivery agent.',
  'If a customer takes delivery and identifies sizing issues or defects afterwards, they must contact "Zerin\'s" within 24 hours of delivery. Upon consideration by "Zerin\'s", we will inform the customer about the action applicable for their case.',
  'Refunds are only applicable if a customer receives a defective product. In all other cases of exchanges and returns, customers will be provided alternative products of the same value OR an equal amount of store credit for future purchases.',
];

const TermsAndConditionsPage = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-6 transition-colors">
        <ArrowLeft className="w-4 h-4" />
        Back to shop
      </Link>

      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8">Terms and Conditions</h1>

      <div className="space-y-6">
        {/* Trial, Exchange and Refund Policy */}
        <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-7">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
              <RotateCcw className="w-5 h-5 text-primary-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Trial, Exchange and Refund Policy</h2>
          </div>

          <ul className="space-y-3.5">
            {REFUND_POLICY_POINTS.map((point, idx) => (
              <li key={idx} className="flex items-start gap-3 text-sm text-gray-700 leading-relaxed">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-400 mt-2 flex-shrink-0" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* Delivery Timing */}
        <section className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 sm:p-7">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-9 h-9 rounded-full bg-primary-50 flex items-center justify-center flex-shrink-0">
              <Truck className="w-5 h-5 text-primary-600" />
            </div>
            <h2 className="text-lg font-semibold text-gray-900">Delivery Timing</h2>
          </div>

          <p className="text-sm text-gray-700 mb-4">Regular deliveries are ensured within the below timelines:</p>

          <div className="grid grid-cols-2 gap-3 mb-5">
            <div className="rounded-xl bg-gray-50 border border-gray-100 px-4 py-3">
              <div className="flex items-center gap-1.5 text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                <Clock className="w-3.5 h-3.5" />
                Inside Dhaka
              </div>
              <p className="text-base font-semibold text-gray-900">1–2 days</p>
            </div>
            <div className="rounded-xl bg-gray-50 border border-gray-100 px-4 py-3">
              <div className="flex items-center gap-1.5 text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                <Clock className="w-3.5 h-3.5" />
                Outside Dhaka
              </div>
              <p className="text-base font-semibold text-gray-900">3–4 days</p>
            </div>
          </div>

          <p className="text-sm text-gray-700 leading-relaxed mb-5">
            <span className="font-semibold text-gray-900">Urgent Deliveries: </span>
            {'If there is an urgency, we can send the product via parcel services (e.g. Pathao Parcel) for which the ' +
              "product's amount needs to be paid in advance via Bkash or Nagad and the delivery charge can be paid as " +
              "cash on delivery to the rider depending on the customer's location from \"Zerin's\" office. The delivery " +
              'charge will depend on the charge shown in the app of the parcel service.'}
          </p>

          <div className="flex items-start gap-2.5 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
            <Info className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
            <p className="text-xs text-amber-800 leading-relaxed">
              The exact delivery time cannot be specified as they are handled by a 3rd party delivery company.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditionsPage;
